
function handleScormToggle() {
  const isScorm = $('#type').is(':checked');
  $('#input-type').val(isScorm ? 'Scorm' : 'Custom');
  
  if (isScorm) {
    $('#validation_percentage').hide();
    $('#scorm_url').show();
    $('#text_question').hide();
  } else {
    $('#validation_percentage').show();
    $('#scorm_url').hide();
    $('#text_question').show();
  }
}

$(() => {
  $('#type').prop('checked', $('#input-type').val() === 'Scorm');
  handleScormToggle();
  $(document).on('click', '#type', handleScormToggle)
});